import React from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import FormikControl from "../CustomedFields/FormikControl";
import { useAuth } from "./../../store/auth-context";

// function CustomerAdd(props, ref) {
const Login = () => {
  const { token, isLoggedIn, login, logout, loginHandler, logoutHandler } =
    useAuth();

  const initialValues = {
    UserName: "",
    Password: "",
  };

  const validationSchema = Yup.object({
    UserName: Yup.string().required("Required"),
    Password: Yup.string().required("Required"),
  });

  const onSubmit = async (values) => {
    console.log("Form data", values.UserName + values.Password);
    login(values.UserName, values.Password);
    // alert("Login submit");
  };

  //********************* Form validation send to Parent form */
  React.useEffect(() => {}, []);

  return (
    <>
      <div className="login-form-bg h-100">
        <div className="container h-100">
          <div className="row justify-content-center h-100">
            <div className="col-xl-6">
              <div className="form-input-content">
                <div className="card login-form mb-0">
                  <div className="card-body pt-5">
                    <a className="text-center" href="#">
                      {" "}
                      <h3>
                        <b>Log in</b>
                      </h3>
                    </a>

                    <Formik
                      initialValues={initialValues}
                      validationSchema={validationSchema}
                      onSubmit={onSubmit}
                    >
                      {(formik) => {
                        return (
                          <Form className="mt-5 mb-5 login-input">
                            <div className="form-group">
                              <FormikControl
                                className="form-control"
                                control="input"
                                type="text"
                                label="User Name"
                                name="UserName"
                                placeholder="User Name"
                              />
                              {/* <input type="email" className="form-control" placeholder="Email"> */}
                            </div>
                            <div className="form-group">
                              <FormikControl
                                className="form-control"
                                control="input"
                                type="password"
                                label="Password"
                                name="Password"
                                placeholder="Password"
                              />
                              {/* <input type="password" className="form-control" placeholder="Password"> */}
                            </div>
                            <button
                              className="btn login-form__btn submit w-100"
                              id="submitButton"
                              type="submit"
                              disabled={
                                !formik.isValid ||
                                !formik.dirty ||
                                formik.isSubmitting
                              }
                            >
                              Login
                            </button>
                          </Form>
                        );
                      }}
                    </Formik>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
